import { MutableRefObject } from 'react';
import { styled } from 'styled-components';
import Input from 'components/ui/Input';

type QuantityCellProps = {
    value: number;
    onChange: (value: string) => void;
    disabled?: boolean;
    rowIndex: number;
    colIndex: number;
    cellInputRefs?: MutableRefObject<{
        [key: string]: unknown;
    }>;
    handleArrowKeyDown?: (e: React.KeyboardEvent, itemId: any, rowIndex: any, colIndex: any) => void;
};

const QuantityCell = ({
    value,
    onChange,
    disabled = false,
    rowIndex,
    colIndex,
    cellInputRefs,
    handleArrowKeyDown,
}: QuantityCellProps) => {
    return (
        <StyledInput
            type="number"
            min={1}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            disabled={disabled}
            rounded
            ref={(el) => {
                if (cellInputRefs && el) {
                    cellInputRefs.current[`additionalCosts-${rowIndex}-${colIndex}`] = el;
                }
            }}
            onKeyDown={(e) => handleArrowKeyDown?.(e, 'additionalCosts', rowIndex, colIndex)}
        />
    );
};

export default QuantityCell;

const StyledInput = styled(Input)`
    width: 100%;
    flex: 1;

    > * {
        font-size: 10px !important;
    }

    input {
        height: 32px !important;
        width: 100% !important;
        padding-left: 8px !important;
    }
`;
